import { getAmplitudeInstance } from '../amplitudeHelpers';

type logCustomRoutePOIExploreSelectedParams = {
  poi_id: number;
};

/**
 * User taps the 'explore this spot' CTA in the menu that pops up after they tap on a POI in the custom route builder
 * @param params - Attributes to log with the amplitude event
 * @param params.poi_id - The id associated with the selected POI
 */
const logCustomRoutePOIExploreSelected = ({ poi_id }: logCustomRoutePOIExploreSelectedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('custom route poi explore selected', { 'poi id': poi_id }, callback);
};

export default logCustomRoutePOIExploreSelected;
